const format = {
  dateFormat: "MM/DD/YYYY",
  timeFormat: "hh:mm A",
  monthFormat: "YYYY/MM",
  dateTimeFormat: "MM/DD/YYYY hh:mm A",
  currencyMask: /\B(?=(\d{3})+(?!\d))/g,
  currencyParser: /\$\s?|(,*)/g,
  checkCommas: /,/g,
  numberFormat: /[^0-9,]/,
};

export default format;
